export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-award-fill',
      title: 'Calidad Premium',
      description: 'Cada impresión es una muestra de poder visual. Solo lo mejor.'
    },
    {
      icon: 'ri-time-fill',
      title: 'Entrega Rápida',
      description: 'Sin pausas ni retrasos. Tu proyecto llega cuando lo necesitas.'
    },
    {
      icon: 'ri-palette-fill',
      title: 'Diseño Personalizado',
      description: 'Ideas con actitud, creadas para marcas que se atreven a destacar.'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Atención 24/7',
      description: 'Tu marca no duerme, nosotros tampoco. Siempre listos para ayudarte.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ¿Por Qué Elegir a LION URBAN?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Porque rugimos con cada proyecto. Mientras otros solo imprimen, nosotros creamos impacto. Convertimos lo común en algo que la gente recuerda. Tu marca no pasa desapercibida cuando lleva el sello Lion Urban.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
